import { Injectable, Injector } from '@angular/core';
import {
  Settlement,
  SettlementFilterParams
} from '../../core/declarations/settlement.interface';

import {
  DefineRepositoryParams,
  RepositoryAbstract
} from './repository.abstract';

export type SettlementRepositoryParams = DefineRepositoryParams<
  Settlement,
  {
    queryParams: SettlementFilterParams;
  }
>;

@Injectable({
  providedIn: 'root'
})
export class SettlementRepository extends RepositoryAbstract<SettlementRepositoryParams> {
  constructor(injector: Injector) {
    super(`/settlements`, injector);
  }
}
